import type { ReactNode } from "react";
import U2000RequireRole from "../u2000Core/components/controls/U2000RequireRole";
import U2104, { U2104ROLES } from "./U2104";
import U2104OrganizationList from "./components/U2104OrganizationList";
import U2104OrganizationForm from "./components/U2104OrganizationForm";
import U2104RoleForm from "./components/U2104RoleForm";
import U2104AffiliationForm from "./components/U2104AffiliationForm";

// Typage pour les routes
interface RouteObject {
  path?: string;
  index?: boolean;
  element?: ReactNode;
  children?: RouteObject[];
}

// Définition des routes pour l'unité logique U2104
const U2104Routes: RouteObject[] = [
  {
    path: "U2104",
    element: <U2000RequireRole allowedRoles={[U2104ROLES.READ]} />,
    children: [
      {
        path: "",
        element: <U2104 />,
        children: [
          { index: true, element: <U2104OrganizationList /> },
          {
            path: ":id/affiliation/:affiliationId",
            element: <U2104AffiliationForm />,
          },
          {
            path: ":id/role/:roleId",
            element: <U2104RoleForm />,
          },
          { path: ":id", element: <U2104OrganizationForm /> },
        ],
      },
    ],
  },
];

export default U2104Routes;
